module.exports = __webpack_public_path__ + "static/media/IMG_3770.e579fb3f.JPG";